import { Fab } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import { useNavigate } from 'react-router-dom';
import { useModulePermission } from '../../utils/useModulePermission';

const FAB_GREEN = '#04CB28';
const FAB_PURPLE = '#7C3AED';

/**
 * Global floating chat FAB; opens chat as a right-side offcanvas drawer (full viewport height).
 */
export default function ChatWidget() {
  const navigate = useNavigate();
  const { can } = useModulePermission('AI Agent');

  if (!can('read')) {
    return null;
  }

  return (
    <Fab
      color="primary"
      aria-label="Open Agentic AI page"
      onClick={() => navigate('/agentic-ai')}
      sx={{
        position: 'fixed',
        right: 24,
        bottom: 24,
        zIndex: (t) => t.zIndex.drawer - 1,
        bgcolor: FAB_PURPLE,
        color: '#fff',
        width: 56,
        height: 56,
        boxShadow: '0 8px 24px rgba(124, 58, 237, 0.35)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease',
        animation: 'chatFabPulse 2.4s ease-in-out infinite',
      
        '@keyframes chatFabPulse': {
          '0%, 100%': {
            boxShadow: '0 8px 24px rgba(124, 58, 237, 0.35)',
          },
          '50%': {
            boxShadow: '0 8px 30px rgba(124, 58, 237, 0.55)',
          },
        },
      
        '&:hover': {
          bgcolor: '#6D28D9',
          transform: 'scale(1.06)',
          filter: 'brightness(1.08)',
          boxShadow: '0 10px 32px rgba(124, 58, 237, 0.5)',
        },
      }}
    >
      <ChatIcon />
    </Fab>
  );
}
